/**
 * Ajuda que vale em todas as telas ("*").
 *
 * Juntada em `../ajudaDosCampos.ts`, que explica a chave e o texto. Ver
 * docs/FRONTEND.md, secao 6.
 */
export const ajuda: Record<string, Record<string, string>> = {
  '*': {
    'Razao social': 'Nome empresarial, como consta no cadastro do CNPJ.',
    CNPJ: 'O servidor confere os digitos verificadores antes de gravar.',
  },
};
